module.exports = __webpack_public_path__ + "img/IMG026.12d9895e.jpg";